import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'

export const DetailField = ({
  label,
  children,
}: {
  label: string
  children: ReactNode
}) => (
  <Box sx={{ mb: 2.5 }}>
    <Typography
      variant="subtitle2"
      sx={{ fontWeight: 700, mb: 0.75, color: 'text.primary' }}
    >
      {label}
    </Typography>
    {children}
  </Box>
)

export const detailTextFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '6px',
    bgcolor: 'common.white',
  },
}

export const greySectionSx = {
  bgcolor: 'grey.100',
  borderRadius: '6px',
  border: '1px solid',
  borderColor: 'grey.300',
  p: 2,
  mb: 2,
}

export const toggleRowSx = {
  ...greySectionSx,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 2,
  py: 1.5,
}

export const primaryActionButtonSx = {
  textTransform: 'none',
  fontWeight: 700,
  borderRadius: '6px',
  minWidth: 120,
  boxShadow: 'none',
}

export const addContactButtonSx = {
  textTransform: 'uppercase',
  fontWeight: 700,
  borderRadius: '6px',
  minWidth: 90,
  height: 40,
  boxShadow: 'none',
}

export const contactAddFieldSx = {
  ...detailTextFieldSx,
  '& .MuiOutlinedInput-root': {
    ...detailTextFieldSx['& .MuiOutlinedInput-root'],
    '& fieldset': {
      borderColor: 'primary.main',
      borderWidth: '1.5px',
    },
  },
}
